import { SettingsDetails } from '../models/settings.model';
import { Observable } from 'rxjs';
export abstract class ISettingsService {
    settingsList$: Observable<any>;
    settingsDetails$: Observable<any>;
    settingsSaveStatus$: Observable<any>;
    abstract fetchUserSettingsSummary(): void;
    abstract fetchUserSettingsDetails(functionName: string, functionType: string): any;
    abstract saveUserSettings(settingsData: any, isForAllSite?: boolean): any;
    abstract modifyUserSettings(settingsData: SettingsDetails, action: string, isRetry?: boolean, isForAllSite?: boolean): any;
}
